// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"auto-complete_dropdownContainer__L19O9","menu":"auto-complete_menu__Q2IWd"};